<template>
  <div />
</template>

<script setup lang="ts">
  import { onMounted } from 'vue'
  import { useRoute } from 'vue-router'

  const route = useRoute()

  const toAbsoluteUrl = (baseUrl: string, fullPath: string): string => {
    const normalizedBase = baseUrl.replace(/\/$/, '')
    return `${normalizedBase}${fullPath}`
  }

  onMounted(() => {
    const reactHost = (import.meta.env as { VUE_CHAT_HOST?: string }).VUE_CHAT_HOST
    const isProxyEntry = window.location.port === '8005'
    const relativeOrAbsoluteTarget =
      !reactHost || isProxyEntry ? route.fullPath : toAbsoluteUrl(reactHost, route.fullPath)

    const absoluteTarget = new URL(relativeOrAbsoluteTarget, window.location.origin).toString()

    // if (absoluteTarget === window.location.href) {
    //   console.error('ReactAppRedirect: redirect target matches current URL.', {
    //     reactHost,
    //     route: route.fullPath,
    //   })
    //   return
    // }

    window.location.assign(absoluteTarget)
  })
</script>
